// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"notification-list_borderBox__an_si","noNotificationsDescription":"notification-list_noNotificationsDescription__BT0lc"};